// extracted by mini-css-extract-plugin
module.exports = {"root":"UnitEconomics_root__1S4Vz","child":"UnitEconomics_child__2EmaJ","totalCost":"UnitEconomics_totalCost__1kEMR","heading1":"UnitEconomics_heading1__3jN8x"};